import { useEffect, useState } from "react";
import "./CardsComposition.scss";
import Card from "../../components/Card/Card";

const DESKTOP_BREAKPOINT = 1024;

function CardsComposition({ cardData, desktopMarquee = false }) {
    const [isDesktopMarquee, setIsDesktopMarquee] = useState(false);

    useEffect(() => {
        if (!desktopMarquee) {
            setIsDesktopMarquee(false);
            return undefined;
        }

        const mediaQuery = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);
        const update = () => setIsDesktopMarquee(mediaQuery.matches);
        update();
        mediaQuery.addEventListener("change", update);

        return () => mediaQuery.removeEventListener("change", update);
    }, [desktopMarquee]);

    const displayData = isDesktopMarquee ? [...cardData, ...cardData] : cardData;

    const renderCard = (card, index) => (
        <Card
            key={`${card.title}-${index}`}
            icon={card.icon}
            title={card.title}
            body={card.body}
            isIcon={!!card.icon}
            isTitle={!!card.title}
            size={card.size}
        />
    );

    return (
        <section
            className={`cards-composition ${
                desktopMarquee ? "cards-composition--desktop-marquee" : ""
            }`}
        >
            <div className="cards-composition__section-wrapper">
                <div
                    className={`cards-composition__track ${
                        isDesktopMarquee ? "cards-composition__track--animated" : ""
                    }`}
                >
                    {displayData.map((card, index) => renderCard(card, index))}
                </div>
            </div>
        </section>
    );
}

export default CardsComposition;
